<template>
  <v-select
    v-model="select"
    @change="update"
    :class="`${color}-type`"
    style="zoom: 0.8; color: white !important"
    :items="items"
    :disabled="loading"
    :loading="loading"
    :readonly="!selectReadOnly"
    :append-icon="selectIcon"
    :menu-props="{ bottom: true, offsetY: true }"
    dense
    outlined
    attach
    hide-details
  ></v-select>
</template>

<script>
import Vue from "vue";
import { getCurrentInstance, onMounted, ref, computed } from "@vue/composition-api";
import { postData } from "@utils";
import { useToast } from "vue-toastification/composition";
import { useCallCenterStore } from "@/stores/callCenter";

// Icon
import { mdiClose, mdiMenuDown } from "@mdi/js";

export default {
  props: ["value", "items", "color", "id"],
  emit: ["tableFetch"],

  setup(props, { emit }) {
    // Utils
    const vm = getCurrentInstance().proxy;
    const toast = useToast();
    const callCenterStore = useCallCenterStore();

    const select = ref(null);
    const loading = ref(false);

    const update = () => {
      loading.value = true;

      postData({
        method: "callCenterChangeOrdState",
        id: props.id,
        ordstate: select.value,
      })
        .then((response) => {
          // API dönüşündeki hatalara bakıyoruz
          if (response.error === 1) {
            throw new Error(response.msg);
          }
          callCenterStore.isOrderStatusChange++;
          toast.success(response.msg);
          emit("tableFetch");
        })
        .catch((e) => {
          // API hataya girdi

          Vue.swal({
            title: "Hata",
            text: e.message,
            width: "350px",
            icon: "error",
            background: "#FF4C51",
            showCloseButton: false,
            showConfirmButton: true,
            confirmButtonColor: "#cc3d41",
          });
        })
        .finally(() => {
          // API işlemi bittikten sonra
          loading.value = false;
        });
    };

    const selectReadOnly = computed(() => {
      const result = [];

      // İstenilen şart
      const condition = (item) => item === true;

      // ŞART 1 => Ability değerlendirme
      vm.$ability.can("state", "callCenter") ? result.push(true) : result.push(false);

      // ŞART 2 => Durum değerlendirme
      select.value < 3 ? result.push(true) : result.push(false);

      return result.every(condition);
    });

    const selectIcon = computed(() => {
      return selectReadOnly.value ? mdiMenuDown : null;
    });

    onMounted(() => {
      select.value = props.value;
    });

    return {
      select,
      loading,
      update,
      selectIcon,
      selectReadOnly,
      icons: {
        mdiClose,
        mdiMenuDown,
      },
    };
  },
};
</script>
